import { render, staticRenderFns } from "./pagePart.vue?vue&type=template&id=13ec47dc&scoped=true"
import script from "./pagePart.vue?vue&type=script&lang=js"
export * from "./pagePart.vue?vue&type=script&lang=js"
import style0 from "./pagePart.vue?vue&type=style&index=0&id=13ec47dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ec47dc",
  null
  
)

export default component.exports